import React, { FunctionComponent, SVGProps } from 'react'

export const IconCheckMedium: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      stroke="white"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 1.00098L3.5 6.50098L1 4.00098"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
